import type { GuessReveal, RoundMode, Sport } from '@geosport/shared';
import { sportLabel } from './SportIcon';
import { QuestionPill } from './QuestionPill';
import { ScoreBox } from './ScoreBox';

function prettyDate(date: string): string {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function TopBar({
  position,
  reveals,
  score,
  mode,
  sport,
  date,
  puzzleNo,
  reducedMotion,
  onMenu,
  specialTitle,
}: {
  position: number;
  reveals: GuessReveal[];
  score: number;
  mode: RoundMode;
  sport: Sport | null;
  date: string;
  puzzleNo: number;
  reducedMotion: boolean;
  onMenu: () => void;
  /** Set while playing a themed special. */
  specialTitle?: string | null;
}) {
  const subtitle = specialTitle
    ? `Special · ${specialTitle}`
    : mode === 'random'
      ? `Random round${sport ? ` · ${sportLabel(sport)}` : ''}`
      : mode === 'archive'
        ? `Replay · #${puzzleNo} · ${prettyDate(date)}`
        : `#${puzzleNo} · ${prettyDate(date)}`;
  return (
    <header className="flex items-center gap-3 bg-ink/85 px-3 py-2 backdrop-blur">
      <button
        type="button"
        onClick={onMenu}
        aria-label="Open menu"
        className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-white/80 hover:bg-white/10"
      >
        <svg
          aria-hidden="true"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        >
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      </button>
      <ScoreBox score={score} reducedMotion={reducedMotion} />
      <div className="ml-auto flex flex-col items-end gap-1">
        <QuestionPill position={position} reveals={reveals} />
        <span className="text-[11px] text-white/55 tabular-nums">{subtitle}</span>
      </div>
    </header>
  );
}
